const datapointsPermissions = (action, permissions, institutionId) => {
  if (
    action.startsWith('datapoints') &&
    permissions[institutionId].includes('THE_STAFF_ACCESS_ALL_INSTITUTIONS')
  ) {
    return true;
  }

  if (
    action === 'datapoints:userAccess' &&
    permissions[institutionId].some((item) =>
      ['DATAPOINTS_USER', 'THE_STAFF_ACCESS_ALL_INSTITUTIONS'].includes(item),
    )
  ) {
    return true;
  }

  if (
    action === 'datapoints:institutionAccess' &&
    permissions[institutionId].some((item) =>
      ['DATAPOINTS_INSTITUTION', 'THE_STAFF_ACCESS_ALL_INSTITUTIONS'].includes(
        item,
      ),
    )
  ) {
    return true;
  }

  if (
    action === 'datapoints:assumeActiveInstitution' &&
    permissions[institutionId].includes('DATAPOINTS_INSTITUTION')
  ) {
    return true;
  }

  if (action === "datapoints:viewPage") {
    const perms = permissions[institutionId];
    return perms && perms.length > 1 && perms.includes("DATAPOINTS_USER");
  }

  return false;
};

module.exports = {
  datapointsPermissions,
};
